<template>
  <v-card :light="!dark">
    <v-card-text>
      <div class="unit-items">
        <div class="unit-title">
          <h3 class="font-weight-regular mb-0 white--text">{{ title }}</h3>
        </div>
        <template v-if="addItem">
          <v-textarea
            color="amber"
            v-model="item.title"
            :rows="1"
            :autoGrow="true"
            class="unit-field"
            :hide-details="true"
          />
          <div class="relative text-right">
            <v-btn light color="amber" class="mt-0 add-button" @click="add"
              >Add</v-btn
            >
          </div>
        </template>
        <draggable
          class="inner mt-5"
          :list="items"
          group="order"
          @start="startDrag()"
          @end="endDrag()"
          :ref="name"
          :id="name"
        >
          <div
            v-for="(item, index) in items"
            :key="`unit-${index}`"
            class="item flexi"
            :data-id="`${Math.round(new Date().getTime() / 1000)}`"
          >
            <v-textarea
              color="amber"
              v-model="item.title"
              :rows="1"
              :autoGrow="true"
              v-if="editMode"
              :hide-details="true"
            />

            <p v-else>
              <span class="font-weight-bold">{{ item.title }}</span
              ><br />{{ item.description }}
              <v-icon
                v-if="editItem"
                class="white--text ma-1"
                @click="editEmit(item)"
                >mdi-pencil</v-icon
              >
            </p>

            <div class="icons" v-if="addItem">
              <v-icon
                @click="edit(index)"
                v-if="editMode && editIndex == index"
                class="white--text ma-1"
                >mdi-check-circle</v-icon
              >
              <v-icon @click="edit(index)" v-else class="white--text ma-1"
                >mdi-pencil</v-icon
              >
              <v-icon
                @click="remove(index)"
                v-if="!editMode"
                class="white--text ma-1"
                >mdi-delete-forever</v-icon
              >
            </div>
          </div>
        </draggable>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import draggable from 'vuedraggable'
export default {
  name: 'OrderedItems',
  data() {
    return {
      items: this.value,
      item: {},
      currIndex: null,
      refs: null,
      fields: [],
      editMode: false,
      editIndex: ''
    }
  },
  props: {
    value: Array,
    name: String,
    title: String,
    dark: {
      type: Boolean,
      default: true
    },
    addItem: {
      type: Boolean,
      default: true
    },
    editItem: {
      type: Boolean,
      default: false
    }
  },
  components: {
    draggable
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val
      },
      deep: true
    }
  },
  mounted() {
    if (this.collection) {
      this.getRefs()
    }
  },
  methods: {
    add() {
      let item = {
        index: this.items.length,
        title: this.item.title,
        id: this.items.length,
        type: 'content'
      }
      this.items.push(item)
      this.item = {}

      this.editMode = false
      this.currId = null
      this.currIndex = null
      this.$emit('autosave')
    },
    remove(index) {
      this.items.splice(index, 1)
      this.$emit('autosave')
    },
    edit(index) {
      this.editMode = !this.editMode
      this.editIndex = index
      this.$emit('autosave')
    },
    editEmit(item) {
      this.$emit('edit', item)
    },
    startDrag() {
      this.dragging = true
    },
    endDrag() {
      let count = 0
      let vm = this
      let div = document.getElementById(this.name)
      div.children.forEach(doc => {
        let item = this.items.find(x => x.id == doc.dataset.id)
        if (item) {
          let indexOfItem = this.items.indexOf(item)
          item.index = count
          vm.$set(vm.items, indexOfItem, item)
        }
        count++
      })
      this.dragging = false
      this.$emit('autosave')
    }
  }
}
</script>

<style lang="scss" scoped>
.flexi {
  display: flex;
  justify-content: space-between;
  .icons {
    margin-right: 25px;
  }
}
.unit-items {
  .item {
    white-space: pre-wrap;
    &--flex {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    padding: 0.5rem;
    margin: 0.5rem 0;
    background: #2b2a2a;
    border-radius: 5px;
    color: white;
    .icons {
      width: 50px;
      padding: 0 10px;
      display: flex;
    }
  }
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
</style>
